export const ISRESULT = 'ISRESULT';
export const DOWNLOAD_FILE = 'DOWNLOAD_FILE';
//New
export const GET_DATA_NEW_PLANHANDLE = 'GET_DATA_NEW_PLANHANDLE';
export const GET_DATA_NEW_PLANHANDLE_SUCCEEDED = 'GET_DATA_NEW_PLANHANDLE_SUCCEEDED';
export const REQUERT_NEW_PLANHANDLE_FAILED = 'REQUERT_NEW_PLANHANDLE_FAILED';
export const SET_DATA_NEW_PLANHANDLE = 'SET_DATA_NEW_PLANHANDLE';
export const UPLOAD_FILE_PLANHANDLE = 'UPLOAD_FILE_PLANHANDLE';
export const UPLOAD_FILE_PLANHANDLE_SUCCEEDED = 'UPLOAD_FILE_PLANHANDLE_SUCCEEDED';
export const UPLOAD_FILE_PLANHANDLE_FAILED = 'UPLOAD_FILE_PLANHANDLE_FAILED';
//PlanHandle
export const GET_DATA_PLANHANDLE_PLANHANDLE = 'GET_DATA_PLANHANDLE_PLANHANDLE';
export const GET_DATA_PLANHANDLE_PLANHANDLE_SUCCEEDED = 'GET_DATA_PLANHANDLE_PLANHANDLE_SUCCEEDED';
export const REQUERT_PLANHANDLE_PLANHANDLE_FAILED = 'REQUERT_PLANHANDLE_PLANHANDLE_FAILED';
export const SET_DATA_PLANHANDLE_PLANHANDLE = 'SET_DATA_PLANHANDLE_PLANHANDLE';
export const CLEAR_DATA_NEW_PLANHANDLE = 'CLEAR_DATA_NEW_PLANHANDLE';
//PlanHandleStep
export const GET_DATA_PLANHANDLESTEP_PLANHANDLE = 'GET_DATA_PLANHANDLESTEP_PLANHANDLE';
export const GET_DATA_PLANHANDLESTEP_PLANHANDLE_SUCCEEDED = 'GET_DATA_PLANHANDLESTEP_PLANHANDLE_SUCCEEDED';
export const REQUERT_PLANHANDLESTEP_PLANHANDLE_FAILED = 'REQUERT_PLANHANDLESTEP_PLANHANDLE_FAILED';
export const SET_DATA_PLANHANDLESTEP_PLANHANDLE = 'SET_DATA_PLANHANDLESTEP_PLANHANDLE';
export const SET_DATA_PLANHANDLESTEP_PLANHANDLE_SUCCEEDED = 'SET_DATA_PLANHANDLESTEP_PLANHANDLE_SUCCEEDED';
export const CLEAR_DATA_PLANHANDLESTEP_PLANHANDLE = 'CLEAR_DATA_PLANHANDLESTEP_PLANHANDLE';
//Filter Report
export const GET_DATA_FILTERREPORT_PLANTYPE = 'GET_DATA_FILTERREPORT_PLANTYPE';
export const GET_DATA_FILTERREPORT_PLANTYPE_SUCCEEDED = 'GET_DATA_FILTERREPORT_PLANTYPE_SUCCEEDED';
export const REQUEST_FILTERREPORT_PLANTYPE_FAILED = 'REQUEST_FILTERREPORT_PLANTYPE_FAILED';
export const CLEAR_DATA_FILTERREPORT_PLANTYPE = 'CLEAR_DATA_FILTERREPORT_PLANTYPE';
// Data Table Report
export const GET_DATA_TABLEREPORT_PLANHANDLE = 'GET_DATA_TABLEREPORT_PLANHANDLE';
export const GET_DATA_TABLEREPORT_PLANHANDLE_SUCCEEDED = 'GET_DATA_TABLEREPORT_PLANHANDLE_SUCCEEDED';
export const REQUEST_DATA_TABLEREPORT_PLANHANDLE_FAILED = 'REQUEST_DATA_TABLEREPORT_PLANHANDLE_FAILED';
export const CLEAR_DATA_TABLEREPORT_PLANHANDLE = 'CLEAR_DATA_TABLEREPORT_PLANHANDLE';
//// Data Haeder Table Report
export const GET_DATA_HEADER_TABLEREPORT_PLANHANDLE = 'GET_DATA_HEADER_TABLEREPORT_PLANHANDLE';
export const GET_DATA_HEADER_TABLEREPORT_PLANHANDLE_SUCCEEDED = 'GET_DATA_HEADER_TABLEREPORT_PLANHANDLE_SUCCEEDED';
export const REQUEST_DATA_HEADER_TABLEREPORT_PLANHANDLE_FAILED = 'REQUEST_DATA_HEADER_TABLEREPORT_PLANHANDLE_FAILED';
export const CLEAR_DATA_HEADER_TABLEREPORT_PLANHANDLE = 'CLEAR_DATA_HEADER_TABLEREPORT_PLANHANDLE';

export const GET_DATA_HISTORY = 'GET_DATA_HISTORY';
export const GET_DATA_HISTORY_SUCCEEDED = 'GET_DATA_HISTORY_SUCCEEDED';
export const REQUERT_DATA_HISTORYE_FAILED = 'REQUERT_DATA_HISTORYE_FAILED';

export const GET_DATA_STATUS_ACTION_HISTORY = 'GET_DATA_STATUS_ACTION_HISTORY';
export const GET_DATA_STATUS_ACTION_HISTORY_SUCCEEDED = 'GET_DATA_STATUS_ACTION_HISTORY_SUCCEEDED';
export const GET_DATA_STATUS_ACTION_HISTORY_FAILED = 'GET_DATA_STATUS_ACTION_HISTORY_FAILED';

//data link api
export const GET_DATA_ACTION_LinkApi = 'GET_DATA_ACTION_LinkApi';
export const GET_DATA_ACTION_LinkApi_SUCCEEDED = 'GET_DATA_ACTION_LinkApi_SUCCEEDED';
export const GET_DATA_ACTION_LinkApi_FAILED = 'GET_DATA_ACTION_LinkApi_FAILED';

//data link api byid
export const GET_DATA_ACTION_LinkApibyid = 'GET_DATA_ACTION_LinkApibyid';
export const GET_DATA_ACTION_LinkApibyid_SUCCEEDED = 'GET_DATA_ACTION_LinkApibyid_SUCCEEDED';
export const GET_DATA_ACTION_LinkApibyid_FAILED = 'GET_DATA_ACTION_LinkApibyid_FAILED';

//Email Azure
export const GET_DATA_EMAIL_AZURE = 'GET_DATA_EMAIL_AZURE';
export const GET_DATA_EMAIL_AZURE_SUCCEEDED = 'GET_DATA_EMAIL_AZURE_SUCCEEDED';
export const REQUEST_DATA_EMAIL_AZURE_FAILED = 'REQUEST_DATA_EMAIL_AZURE_FAILED';

//GetValidateDate
export const GET_DATA_VALIDATE_DATE = 'GET_DATA_VALIDATE_DATE';
export const GET_DATA_VALIDATE_DATE_SUCCEEDED = 'GET_DATA_VALIDATE_DATE_SUCCEEDED';
export const REQUEST_GET_DATA_VALIDATE_DATE_FAILED = 'REQUEST_GET_DATA_VALIDATE_DATE_FAILED';
//GetPlanByPassCreate
export const GET_DATA_PLAN_BY_PASS = 'GET_DATA_PLAN_BY_PASS'
export const GET_DATA_PLAN_BY_PASS_SUCCEEDED = 'GET_DATA_PLAN_BY_PASS_SUCCEEDED'
export const REQUEST_DATA_PLAN_BY_PASS_FAILED = 'REQUEST_DATA_PLAN_BY_PASS_FAILED'
//IndexHygen